"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const fmko_ts_widgets_1 = require("fmko-ts-widgets");
const NumberFieldSchemaComponent_1 = require("./NumberFieldSchemaComponent");
const SchemaColumnConfig_1 = tslib_1.__importDefault(require("../../schema/SchemaColumnConfig"));
class NumberFieldSchemaColumnConfig extends SchemaColumnConfig_1.default {
    constructor({ title, titleVisible, mapDataToCell, mapCellToData, headerClassName = new Set(), defaultUnitText, hasUnitText = true, extraClasses = [] }) {
        super({
            headerStyle: headerClassName,
            heading: title,
            mapDataToTD: mapDataToCell
        });
        this.numberFields = [];
        this.enabled = true;
        this.unitText = defaultUnitText;
        if (titleVisible) {
            if (this.headerStyle instanceof Set) {
                this.headerStyle.add("header-visible");
            }
        }
        const that = this;
        this.renderer = {
            render(ctx, obj) {
                const { inputValue } = obj.inputAndUnit || {};
                const { row } = ctx;
                const numberField = new NumberFieldSchemaComponent_1.NumberFieldSchemaComponent({
                    allowDecimals: true,
                    fieldSizeClass: fmko_ts_widgets_1.FieldSize.MAX,
                    hasUnitText,
                    label: "Talfelt",
                    labelHidden: true,
                    renderingContext: ctx
                });
                numberField.setValue({ inputValue, unitValue: that.unitText });
                numberField.addCssClass(...extraClasses);
                numberField.addValueChangeHandler(() => {
                    const data = [...that.grid.getValue()];
                    data[row] = {
                        ...(data[row] ?? {}),
                        ...mapCellToData(data[row], numberField.getValue())
                    };
                    setTimeout(() => that.grid.setValue(data, true));
                });
                that.numberFields.push(numberField);
                ctx.setWidget(numberField);
                numberField.setEnabled(that.enabled);
                that.setCellElementEnabled(ctx.currentCell, that.enabled);
            },
            canRender(_o) {
                return true;
            }
        };
    }
    setEnabled(enabled) {
        this.enabled = enabled;
        for (const numberField of this.numberFields) {
            numberField.setEnabled(enabled);
            this.setCellElementEnabled(numberField.element.parentElement, enabled);
        }
    }
    getNumberFields() {
        return this.numberFields;
    }
    setUnitText(unitText) {
        this.unitText = unitText;
        for (const textField of this.numberFields) {
            textField.setUnitText(this.unitText);
        }
    }
    clear() {
        this.numberFields = [];
    }
    getData(data) {
        return {
            data: data,
            inputAndUnit: this.mapDataToTD(data)
        };
    }
}
exports.default = NumberFieldSchemaColumnConfig;
//# sourceMappingURL=NumberFieldSchemaColumnConfig.js.map